(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-filter-section"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  
  class CollectionFilter {
    constructor() {
      this.filterContainer = document.querySelector('[data-collection-filters]');
      this.filterButtons = document.querySelectorAll('[data-filter-button]');
      this.init();
    }

    init() {
      if (!this.filterContainer) return;

      // Add click handlers for filter buttons
      this.filterButtons.forEach(button => {
        button.addEventListener('click', (e) => this.handleFilterClick(e));
      });

      // Smooth scroll after page load (if filter is active)
      if (window.location.search.includes('filter') || this.hasActiveFilters()) {
        this.smoothScrollToFilters();
      }
    }

    handleFilterClick(e) {
      // Add loading state
      this.addLoadingState();
      // Let the default link behavior happen (page reload)
    }

    hasActiveFilters() {
      return document.querySelector('.filter-button.active') !== null;
    }

    addLoadingState() {
      if (this.filterContainer) {
        this.filterContainer.classList.add('loading');
      }
    }

    smoothScrollToFilters() {
      setTimeout(() => {
        if (this.filterContainer) {
          const offset = 100;
          const elementPosition = this.filterContainer.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new CollectionFilter();
    });
  } else {
    new CollectionFilter();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
